import { IconProps } from '../types/types';

export const BookmarkIcon = ({ className, size = 20, checked = false }: IconProps) => {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            data-name="Line Color"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <path
                d="m12 17-7 4V4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v17Z"
                style={{
                    fill: checked ? '#34b233' : 'none',
                    strokeLinecap: 'round',
                    strokeLinejoin: 'round',
                    strokeWidth: 2,
                }}
            />
        </svg>
    );
};
